import { Type } from '@angular/core';

import { UserPrefsStoreThemeEffects } from './effects.theme';



export const effects: Type<any>[] = [
	UserPrefsStoreThemeEffects,
];
